module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/CircleDotted.149db90d.svg";